import React, { Component } from 'react';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import FontAwesome from 'react-fontawesome'
import { FormGroup, Form, Button } from 'react-bootstrap'
import { Box } from 'reactjs-admin-lte'
import Select from 'react-select'
import StockStore from 'stores/StockStore'
import WorkdocStore from 'stores/WorkdocStore'
var NotificationSystem = require('react-notification-system');
class ImportMasterData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: {},
      data: [],
      cols: [],
      masterfield_item: [],
      masterdata_items: [],
      map_fields: [],
      warehouse: [],
      warehouse_id: '',
      pull_data: false
    }
    this.handleFile = this.handleFile.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadMasterData()
  }

  loadMasterData() {
    let {api} = this.props
    if (api==='masterdata') {
      StockStore.loadMasterData((result)=>{
        let {masterdata_items,warehouse} = this.state
        masterdata_items = result.data.columns.map((item,index)=>{
          return {is_required:item.is_required,label:(item.is_required?<span>{item.field} <span className='text-red'>*</span></span>:item.field),value:item.field}
        })
        warehouse = result.data.warehouse.map((item,index)=>{
          return {label:item.name,value:item.warehouse_id}
        })
        this.setState({warehouse:warehouse,masterdata_items:masterdata_items,masterfield_item:JSON.parse(JSON.stringify(masterdata_items))})
      })
    } else if (api==='wage_masterdata') {
      WorkdocStore.loadWageMasterData((result)=>{
        let {masterdata_items,warehouse} = this.state
        masterdata_items = result.data.columns.map((item,index)=>{
          return {is_required:item.is_required,label:(item.is_required?<span>{item.field} <span className='text-red'>*</span></span>:item.field),value:item.field}
        })
        warehouse = result.data.category.map((item,index)=>{
          return {label:item.name,value:item.id}
        })
        this.setState({warehouse:warehouse,masterdata_items:masterdata_items,masterfield_item:JSON.parse(JSON.stringify(masterdata_items))})
      })
    } else if (api==='customer_masterdata') {
      WorkdocStore.loadCustomerMasterData((result)=>{
        let {masterdata_items,warehouse} = this.state
        masterdata_items = result.data.columns.map((item,index)=>{
          return {is_required:item.is_required,label:(item.is_required?<span>{item.field} <span className='text-red'>*</span></span>:item.field),value:item.field}
        })
        warehouse = result.data.group.map((item,index)=>{
          return {label:item.group_name,value:item.customer_group_id}
        })
        this.setState({warehouse:warehouse,masterdata_items:masterdata_items,masterfield_item:JSON.parse(JSON.stringify(masterdata_items))})
      })
    }  
  }
 
  handleChange(e) {
    const files = e.target.files;
    if (files && files[0]) this.setState({ file: files[0] });
  };
 
  handleFile(e) {
    e.preventDefault()

    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
 
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws);
      /* Update state */
      let {map_fields} = this.state
      if (data.length>0) {
        map_fields = Object.keys(data[0]).map((key,index)=>{
          return {field:key,map_field:''}
        })
      }  
      this.setState({ pull_data:true, map_fields: map_fields, data: data, cols: make_cols(ws['!ref']) }, () => {
        // console.log(JSON.stringify(this.state.data, null, 2));
      });
 
    };
 
    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    };
  }

  renderRow(headerKeys,item){
    //const keys = Object.keys(item)
    let content=[]
    let i = 0
    for (const key of headerKeys) {
      let val = item[key]
      val = parseFloat(val)
      let textAlign = (isNaN(val)||val===''||val===null||val===undefined?'text-left':'text-right')
      content.push(<td className={textAlign} key={i}>{item[key]}</td>)
      i++
    }
    return content
  }

  onImportClick() {
    let postData = []
    let {api} = this.props
    let {data,map_fields,masterfield_item,warehouse_id} = this.state
    let errorMap = true 
    let errorRequired = true
    data.forEach((item,index)=>{
      postData.push()
      masterfield_item.forEach((sitem,sindex)=>{
        let hasField = map_fields.findIndex(x=>x.map_field===sitem.value)
        if (hasField!==-1) {
          errorMap = false
          if (sitem.is_required)
            errorRequired = false
          
          postData[index] = Object.assign({[sitem.value]:item[map_fields[hasField].field]},postData[index])
        } else {
          postData[index] = Object.assign({[sitem.value]:''},postData[index])
        }
      })
    })
    if (warehouse_id==='') {
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:(api==='wage_masterdata'?'กรุณาเลือกหมวดหมู่':api==='customer_masterdata'?'กรุณาเลือกกลุ่มลูกค้า':'กรุณาเลือกคลังสินค้า'),
        level:'error',
        position:'tc'
      });
      return false
    }
    if (errorMap) {
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'กรุณาเลือก Columns เพื่อจับคู่ข้อมูล',
        level:'error',
        position:'tc'
      });
      return false
    }
    if (errorRequired) {
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'กรุณาเลือก Columns ที่มีเครื่องหมาย *',
        level:'error',
        position:'tc'
      });
      return false
    }
    
    if (api==='wage_masterdata') {
      let _postData = {category_id:warehouse_id,data:postData}
      WorkdocStore.saveWageMasterData(_postData,(result)=>{
        this.onAfterSave(result)
      },()=>{
        this.noticeFailSave()
      })
    } else if (api==='customer_masterdata') {
      let _postData = {customer_group_id:warehouse_id,data:postData}
      WorkdocStore.saveCustomerMasterData(_postData,(result)=>{
        this.onAfterSave(result)
      },()=>{
        this.noticeFailSave()
      })
    } else {
      let _postData = {warehouse_id:warehouse_id,data:postData}
      StockStore.saveMasterData(_postData,(result)=>{
        this.onAfterSave(result)
      },()=>{
        this.noticeFailSave()
      })
    }
  }

  onAfterSave(result) {
    if (result.status==='OK') {
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'ทำรายการสำเร็จ',
        level:'info',
        position:'tc'
      });
    }
  }

  noticeFailSave() {
    this._notificationSystem.addNotification({
      title:'แจ้งเตือน',
      message:'ทำรายการไม่สำเร็จ',
      level:'error',
      position:'tc'
    });
  }

  onMapFieldChange(index,key,e) {
    let {map_fields,masterdata_items} = this.state
    if (e!==null) {
      map_fields[index].map_field = e.value
      let rowDisabled = masterdata_items.findIndex(x=>x.value===e.value)
      if (rowDisabled!==-1)
        masterdata_items[rowDisabled] = Object.assign({disabled:true},masterdata_items[rowDisabled])
      
      this.setState({map_fields:map_fields,masterdata_items:masterdata_items})
    } else {
      let rowClear = masterdata_items.findIndex(x=>x.value===map_fields[index].map_field)
      if (rowClear!==-1) {
        delete masterdata_items[rowClear].disabled
        map_fields[index].map_field = ''
      }  
      this.setState({masterdata_items:masterdata_items})  
    }  
  }

  onWarehouseChange(e) {
    this.setState({warehouse_id:e.value})
  }

  renderHeaderSelect(item){
    let {map_fields,masterdata_items} = this.state
    const keys = Object.keys(item)
    return keys.map((key,index)=>(
      <th key={index}>
            <Select
              placeholder='เลือก'
              clearable={true}
              value={map_fields[index].map_field}
              options={masterdata_items}
              onChange={this.onMapFieldChange.bind(this,index,key)}
            />
      </th>
    ))
  }

  renderHeader(item){
    const keys = Object.keys(item)
    return keys.map((key,index)=>(
      <th key={index}>{key}</th>
    ))
  }

  getHeaderKeys(data){
    const keys = data.length>0?Object.keys(data[0]):[]

    return keys
  }
 
  render() {
    let {data,file,warehouse,warehouse_id,pull_data} = this.state
    let {api} = this.props
    let headerKeys = this.getHeaderKeys(data)
    return (
      <div>
        <Box>
          <Box.Header border={true}>
            <Box.Title>
              {api==='wage_masterdata'?'อับโหลด Wage Master Data'
              :api==='customer_masterdata'?'อับโหลด Customer Master Data'
              :'อับโหลด Master Data ไปยังสต็อก'}
            </Box.Title>
          </Box.Header>
          <Box.Body>
            <Form inline>
              <FormGroup>
                <div className='btn-select-file' style={{display:'inline'}}>
                  <div className='btn btn-md btn-primary'>
                    <FontAwesome name='file-excel-o' /> เลือกไฟล์
                    <input type="file" id="file" accept={SheetJSFT} onChange={this.handleChange} />
                  </div>
                </div>
              </FormGroup>
              {typeof file.name!=='undefined'?
              <span>
                {' '}
                <FormGroup>
                  <Button type='submit' onClick={this.handleFile} >
                    <FontAwesome name='download' /> ดึงข้อมูลจากไฟล์
                  </Button>
                </FormGroup>
              </span>  
              :''}
              {pull_data?
              <span>
                {' '}
                <FormGroup>
                  <Select
                    placeholder={api==='wage_masterdata'?'เลือกหมวดหมู่':api==='customer_masterdata'?'เลือกกลุ่มลูกค้า':'เลือกคลังสินค้า'}
                    style={{width:'200px'}}
                    clearable={false}
                    options={warehouse}
                    value={warehouse_id}
                    onChange={this.onWarehouseChange.bind(this)}
                  />
                </FormGroup>  
              </span>  
              :''}
              {pull_data?
              <span>
                {' '}
                <FormGroup>
                  <Button bsStyle='success' onClick={this.onImportClick.bind(this)}><FontAwesome name='check' /> Import</Button>
                </FormGroup>
              </span>  
              :''}
            </Form>  
            <div>{typeof file.name!=='undefined'?file.name:''} {pull_data?'จำนวน '+data.length+' รายการ':''}</div>
            <br />
            <div>
              <table className='table table-hover table-bordered-solid'>
                <thead>
                    <tr>
                      {data.length>0?this.renderHeaderSelect(data[0]):''}
                    </tr>
                    <tr>
                      {data.length>0?this.renderHeader(data[0]):''}
                    </tr>
                </thead>
                <tbody>
                  {data.map((row,index)=>(
                    <tr key={index}>
                      {this.renderRow(headerKeys,row)}  
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Box.Body>
        </Box>
        <NotificationSystem ref="notificationSystem" />    
      </div>
    )
  }
}

ImportMasterData.defaultProps = {
  api:'masterdata'
}
 
export default ImportMasterData;


// WEBPACK FOOTER //
// ./src/view/stock/ImportMasterData.js